module.exports = __webpack_public_path__ + "assets/c80d5faf0e5a8b1a20179efb6114b14f.png";